<template>
  <div ref="view" class="goods-page" :style="`padding-bottom:${FooterHeight}px`">
    <!-- 菜单栏（内嵌App时隐藏） -->

    <app-header :title="title" back-type="back-app" />

    <!-- 无限卡 -->
    <!-- <goods-vip-forever v-if="isVipForever" ref="vipForever" :goods="defaultGoods" /> -->
    <!-- 无限卡增订版 -->
    <!-- <goods-vip-forever2021 v-else-if="isVipForeverIncrease" ref="vipForever2021" :goods="defaultGoods" /> -->
    <!-- <goods-vip-forever2022 v-else-if="isVipForeverIncrease" ref="vipForever2022" :goods="defaultGoods" /> -->
    <!-- 通用商品内容 -->
    <goods-content :content="guideContent || goodsInfo.goodsContent" class="content" />

    <!-- 商品加载出来再显示, 多商品弹窗 -->
    <div v-if="isShow" class="mask" @touchmove.prevent @click="isShow = false">
      <div class="wrap" @click.stop>
        <span class="closeMask" @click="isShow = false">
          <img src="../../images/goods/close.png" alt="" />
        </span>
        <dl flex>
          <dt class="share-icon">
            <img :src="goodsInfo.shareImg" alt="" />
          </dt>
          <dd class="good-info">
            <p class="good-name">{{ goodsInfo.goodsName }}</p>
            <p class="good-price">¥{{ goodsInfo.salePrice }}</p>
          </dd>
        </dl>
        <div class="goods-item">
          <p class="tit">您已选择</p>
          <p class="good-name">
            <span
              :class="[goodsIndex === index ? 'active' : '']"
              @click="chooseGoodsFn(index, item.agreementType, item)"
              v-for="(item, index) in goodsDetail"
              :key="item.goodsId"
            >
              {{ item.goodsName }}
            </span>
          </p>
        </div>
        <button class="btn btn-active" @click="onClickPay">立即购买</button>
      </div>
    </div>
    <!-- 畅听卡协议   协议不为0 且非无限卡|无限卡增订版 -->
    <div
      class="warning"
      :style="`bottom:${FooterHeight}px`"
      @click="checkProtocol"
      v-if="protocolType !== 0 && !(isVipForever || isVipForeverIncrease)"
      v-cloak
    >
      <!-- <div class="warning" @click="checkProtocol" v-cloak> -->
      点击支付即同意
      <span class="warning-text">{{ protocolName }}</span>
    </div>
    <div class="warning tyy-text" :style="`bottom:${FooterHeight}px`" v-if="goodsInfo.goodsType === '40001'">
      本期开营时间：{{ battleStartDateText }}
    </div>
    <!-- 积分商品支付btn -->
    <div v-if="fromIntegral" class="foot">
      <div class="footer">
        <p class="price">
          <span class="shop-price-integral">
            支付:
            <span>{{ goodsInfo.creditVal || '0' }}{{ integralName }}</span>
          </span>
          <span class="original-price" v-if="integralInfo.disCountNum">
            余额不足还差{{ integralInfo.disCountNum }}{{ integralName }}
          </span>
        </p>
        <button class="btn" @click="onIntegralClickFn">
          {{ integralInfo.btnStr }}
        </button>
      </div>
    </div>
    <!--其它类型 购买btn -->
    <div v-else class="foot">
      <!-- 活动立减 -->
      <div class="activity_box flexbox" v-if="hasActivity">
        <div class="act_left flexbox">
          <img src="../../images/goods0929/left.png" alt="" />
          现在报名立减
          <span>{{ defaultGoods.subAmount }}</span>
          元
        </div>
        <div class="act_right flexbox">
          优惠倒计时:
          <CountDown :time="defaultGoods.countDownFormat">
            <template #default="timeData">
              <div class="flexbox countDown_box">
                <div v-show="timeData.days > 0">
                  <span v-for="(item, index) in zero(timeData.days)" :key="index">{{ item }}</span>
                  天
                </div>
                <div>
                  <span v-for="(item, index) in zero(timeData.hours)" :key="index">{{ item }}</span>
                  时
                </div>
                <div>
                  <span v-for="(item, index) in zero(timeData.minutes)" :key="index">{{ item }}</span>
                  分
                </div>
                <div>
                  <span v-for="(item, index) in zero(timeData.seconds)" :key="index">{{ item }}</span>
                  秒
                </div>
              </div>
            </template>
          </CountDown>
        </div>
      </div>
      <!-- 操作栏 -->
      <div class="footer">
        <p class="price" :class="{ 'price-wxk': ygOrderAmount !== null }">
          <span class="shop-price">
            <span class="price-text">预估到手价：</span>
            ¥{{ ygOrderAmount !== null ? ygOrderAmount : salePrice }}
          </span>
          <del class="original-price" v-if="ygOrderAmount !== null">¥{{ salePrice }}</del>
          <del class="original-price" v-else-if="goodsInfo.scribingPrice">¥{{ goodsInfo.scribingPrice }}</del>
        </p>
        <!-- goodsType -->
        <button
          class="btn"
          :class="{ 'btn-click-disable': clickDisable }"
          @click="onClickFn"
          v-if="goodsType === '80001'"
        >
          立即支付
        </button>
        <button class="btn" v-else :class="{ 'btn-click-disable': clickDisable }" @click="onClickFn">
          {{ buttonInfo }}
        </button>
      </div>
      <!-- 无限卡| 无限卡增订版 协议 -->
      <div
        class="flexbox protocol_box"
        @click.stop="setProtocol"
        v-if="(protocolType !== 0 && (isVipForever || isVipForeverIncrease)) || protocolType === 8"
        v-cloak
      >
        <img class="choose_img_box" v-if="!protocolBool" src="../../images/goods0929/no_check.png" alt="" />
        <img class="choose_img_box" v-else src="../../images/goods0929/checked.png" alt="" />
        同意
        <span class="warning_text" @click.stop="checkProtocol">{{ protocolName }}</span>
      </div>
    </div>
    <!-- 订单弹幕气泡 -->
    <order-userbar v-if="buttonInfo === '立即报名'" :options="{ isVipForever, isVipForeverIncrease }" />
    <Popup v-model="messageShow" class="border-message-popup" :closeable="true">
      <div class="message-popup">
        <div class="txt-center mb16" v-html="errorData.errorMessage" style="font-weight: bold"></div>
        <div class="txt-center">
          <img :src="errorData.adviserCode" alt="" />
        </div>
        <div class="btn-common" v-if="!appUser.isWeixin" @click="!appUser.isNative ? getUrlScheme() : nativeGoMini()">
          立即添加班主任
        </div>
        <div class="txt-center text" v-else>长按识别二维码 联系班主任</div>
      </div>
    </Popup>
  </div>
</template>

<script>
import { CountDown, Dialog, Popup } from 'vant'
import { mapGetters } from 'vuex'
import { Toast, MessageBox } from 'mint-ui'
import Body from '@/mixins/body'
import { appUser, throttle, toFixedFloat, goodTypeStr } from '@/utils'
import { $gotoPosterPage, $openWebPage } from '@/utils/common/native-api'
import { getPageUrl } from '@/utils/common/url'
import { toLoginView } from '@/utils/init/env-init'
import GoodsComponents from './components/goods'
import { bindUserReferrer } from '@/utils/bindUserReferrer'
import { sub } from '@/utils/compute-util'
import { saTrack } from '@/utils/common/shence'
import { getCookie } from '@/utils/common/cookie'
import { getAccountId } from '@/utils/init/pubs'
import { activityService } from '@/api'
import goWeixin from '@/utils/goWeixin'
import { orderService } from '@/api'
import { $gotoMiniProgramV2 } from '@/utils/common/native-api'

// 操作名称
const action = 'buyGoods'

export default {
  name: 'goods',
  components: {
    ...GoodsComponents,
    CountDown,
    Popup
  },
  data() {
    return {
      appUser,
      title: '友邻少年',
      goodsList: [],
      goodsIndex: 0, // 选择购买商品的索引
      isShow: false,
      shareIcon: '',
      name: '',
      price: '',
      hasConfirmToBuy: false, // 弹窗确认
      buttonInfo: '立即报名',
      protocolName: '',
      protocolType: 0, // 协议分类：1:无限卡，2:新无限卡，3:外刊年卡，4:全站卡,0:无协议
      canClick: true,
      protocolBool: false, // 协议勾选
      FooterHeight: 60,
      preCreateDetail: null, //预创建订单信息\
      saData: {
        web_type: '商品',
        web_name: '购买落地页'
      },
      goodsInfoList: {},
      vipActivityGoodsId: appUser.isTestEnv ? 104307 : 111039,
      createLoading: false,
      messageShow: false,
      errorData: {},
      ygOrderAmount: null
    }
  },
  mixins: [Body],
  computed: {
    ...mapGetters('user/login', ['getWXUser', 'user']),
    ...mapGetters('integral/index', ['integralName', 'goodsIndexInfo']),
    ...mapGetters('goods/vip', [
      'goodsDetail',
      // 限购规则
      'limitData'
    ]),
    ...mapGetters('payment/order', ['disCountOrderList']),
    ...mapGetters('args', ['goodsIds', 'shareCode', 'fromIntegral', 'fromLogin']),
    // 积分商品兑换信息
    integralInfo() {
      const { goodsIndexInfo, goodsInfo } = this
      console.log('goodsIndexInfo', goodsIndexInfo, goodsInfo.creditVal)
      let disCountNum = 0
      let btnStr = '立即兑换'
      if (goodsIndexInfo.available < goodsInfo.creditVal) {
        disCountNum = sub(goodsInfo.creditVal, goodsIndexInfo.available)
        btnStr = '获得积分'
      } else {
        disCountNum = 0
        btnStr = '立即兑换'
      }
      return {
        btnStr,
        disCountNum
      }
    },
    // 商品是否联合限购
    hasLimit() {
      const { hasLimit } = this.limitData || {}
      return hasLimit
    },
    // 是无限卡购买（VIP商品 & 权益类型无限）
    isVipForever() {
      const { goodsInfo } = this
      const { goodsType, equityType } = goodsInfo
      return goodsType === '50001' && equityType === 'forever'
    },
    // 是否显示购买协议
    isShowProtocol() {
      const { goodsInfo } = this
      const { agreementType } = goodsInfo
      return agreementType !== 0
    },
    // 是否是无限卡增订版
    isVipForeverIncrease() {
      const { goodsInfo } = this
      const { goodsType, equityType } = goodsInfo
      return goodsType === '50001' && equityType === 'renewal'
    },
    // 是否是无限卡-家庭卡
    isSubVipForever() {
      const { goodsInfo } = this
      const { goodsType, equityType } = goodsInfo
      return goodsType === '50001' && equityType === 'subVip'
    },

    // 是否是无限卡增订版 的增订商品 比如1元续订
    isIncrease() {
      const { goodsInfo } = this
      const { goodsType, equityType } = goodsInfo
      return goodsType === '50001' && equityType === 'renewal_year'
    },
    goodsInfo() {
      return this.goodsDetail[this.goodsIndex] || {}
    },
    // shareCode 转换后的 goodsId
    defaultGoods() {
      const { goodsDetail: list } = this
      return list.length ? list[0] : {}
    },
    defaultGoodsId() {
      return this.defaultGoods.goodsId
    },
    // 计算实际支付金额
    discountTotal() {
      const total = this.disCountOrderList.discountTotal
      return total.toFixed(2)
    },
    hasActivity() {
      const { goodsInfo } = this
      if (goodsInfo.hasActivity === 1) return true
      return false
    },
    salePrice() {
      const { goodsInfo } = this
      if (goodsInfo === null) return 0
      // const { subAmount, hasActivity } = goodsInfo
      // const sub = hasActivity === 1 ? subAmount : 0
      let salePrice = goodsInfo.salePrice || 0
      if (this.isVipForever) {
        salePrice = salePrice - this.discountTotal
      }
      // 计算活动优惠金额
      // salePrice = salePrice - sub
      salePrice = salePrice < 0 ? 0 : toFixedFloat(salePrice, 2)
      return salePrice
    },
    clickDisable() {
      return !this.canClick
    },
    // 商品类型
    goodsType() {
      const { goodsInfo } = this
      const { goodsType } = goodsInfo
      return goodsType
    },
    guideContent() {
      if (this.goodsInfo.goodsGuideName) {
        let data = this.goodsInfo.goodsGuideList.find(item => item.guideName === this.goodsInfo.goodsGuideName)
        return data ? data.guideContent : this.goodsInfo.guideContent
      } else if (this.goodsInfo.guideContent) {
        return this.goodsInfo.guideContent
      } else {
        return false
      }
    },
    battleStartDateText() {
      if (!this.goodsInfo.battleStartDate) return null
      let date = new Date(this.goodsInfo.battleStartDate.replace(/-/g, '/'))
      let m = date.getMonth() + 1
      let d = date.getDate()
      return m + '月' + d + '日'
    }
  },
  created() {
    let goodsIds
    if (this.$route.query !== undefined) {
      // 通过路由跳转来的页面,参数在 route 里取
      goodsIds = this.$route.query.goodsId || ''
    } else {
      // 通过链接过来, 参数由 URL 解析出来,并且通过 vuex 传到这个组件 mapGetters
      goodsIds = this.goodsIds || ''
    }
    this.goodsIdArr = goodsIds ? goodsIds.split('-').map(parseInt) : []
    if (this.$route.query.type === 'login' || this.fromLogin) {
      if (!this.hasUser()) {
        return
      }
    }
    this.getGoodsDetail()
  },
  activated() {
    // 解决从副卡提交资料页面数据没刷新的问题, 副卡暂时不卖了
    // 2022年11月08日  暂时注释, pc端微信浏览器内点开会重复reload;
    // const submitDetailsReload = sessionStorage.getItem('submitDetailsReload')
    // if (submitDetailsReload === '1') {
    //   sessionStorage.setItem('submitDetailsReload', '2')
    //   location.reload();
    // }
  },
  mounted() {
    console.log('监听屏幕切换')
    window.addEventListener('onorientationchange' in window ? 'orientationchange' : 'resize', this.renderResize, false)
    this.$nextTick(_ => {
      this.FooterHeight = document.querySelector('.foot').clientHeight
      console.log('FooterHeight', this.FooterHeight)
    })
    window.loginDidChanged = () => {
      appUser.getNativeUser()
      this.getGoodsDetail()
      console.log('first11111')
    }
  },
  beforeDestroy() {
    window.removeEventListener(
      'onorientationchange' in window ? 'orientationchange' : 'resize',
      this.renderResize,
      false
    )
  },
  methods: {
    setProtocol() {
      this.protocolBool = !this.protocolBool
    },
    renderResize() {
      console.log('屏幕切换啦')
      const { style, clientWidth, clientHeight } = document.documentElement
      if (window.orientation === 180 || window.orientation === 0) {
        // 竖屏
        style.fontSize = Math.min(clientWidth, clientHeight) / 7.5 + 'px'
      }
      if (window.orientation === 90 || window.orientation === -90) {
        // 横屏
        style.fontSize = Math.max(clientWidth, clientHeight) / 7.5 + 'px'
      }
      console.log('屏幕切换啦clientWidth:', clientWidth, clientHeight)
    },
    // 微信登录后，再次获取用户数据
    getWXUserAfter_getData() {
      const { goodsDetail: list } = this
      console.log(this.goodsDetail, JSON.parse(JSON.stringify(appUser)), 'opop')
      if (list.length === 1) {
        // USER-LOGIN-NEXT-ACTION: {"type":"button","action":"buyGoods"}
        console.log(this.user.userId, '微信11111')
        this.enterAfterLogin(list, false)
      } else {
        this.getGoodsDetail()
      }
    },
    // 创建预付订单
    preCreate({ goodsId }, noMessage) {
      const userId = appUser.userId
      const { limitData, isVipForever, isVipForeverIncrease } = this
      // 切换预创建订单服务
      const preCreate = () => {
        const data = { goodsId, userId }
        if (this.hasLimit) {
          Object.assign(data, limitData)
          return this.$store.dispatch('payment/order/preCreateByLimit', data)
        } else {
          return this.$store.dispatch('payment/order/preCreate', data)
        }
      }
      const preOrder = preCreate()
      preOrder.catch(({ code, message, data }) => {
        if (noMessage) return
        saTrack('signUpClick', {
          ...this.saData,
          result: message
        })
        console.log(this.goodsInfo, code, data)
        // 已经达到购买上限 | 用户已经具备该商品权益，无需购买商品 | 已经购买过训练营
        if (appUser.isNative && code === 30010) {
          // Toast({ message: '您已经具备该商品，无需购买', position: 'middle' })
          this.makeSatrack(this.goodsInfo, true)
          return
        }
        if ([30425, 30025, 30430, 30443].indexOf(code) >= 0) {
          this.errorData = data
          switch (code) {
            case 30425:
              this.errorData.errorMessage = `您已购买商品或已获得更高权益<br/>详情请咨询班主任`
              break
            case 30025:
              this.errorData.errorMessage = `您已购买过体验营，详情请咨询班主任`
              break
            case 30430:
              this.errorData.errorMessage = `您已购买过体验营，请联系班主任，激活课程权益`
              break
            case 30443:
              this.errorData.errorMessage = `该商品仅支持友邻少年无限卡用户购买<br/>详情请咨询班主任`
              break
            default:
              this.errorData.errorMessage = message
              break
          }
          this.messageShow = true
          return
        }
        // 购买副卡时,发现账户有分期订单
        if (code === 30143) {
          Dialog.confirm({
            message: message,
            confirmButtonText: '去还款',
            confirmButtonColor: '#00B25A'
          })
            .then(() => {
              const url = getPageUrl({
                page: 'payment-installment.html',
                route: '/installment'
              })
              console.log('当前跳转地址-', url)
              if (appUser.isNative) {
                $openWebPage(url)
              } else {
                window.location.href = url
              }
            })
            .catch(() => {
              // on cancel
            })
        }
        if (code === 30404) {
          // Toast({ message: '您当前未拥有无限卡权益无法购买增订商品', position: 'middle' })
          this.makeSatrack(this.goodsInfo, true)
          return
        }
        // 训练营招生结束！
        if (code === 30067) {
          this.makeSatrack(this.goodsInfo, true)
          // Toast({ message, position: 'middle' }) 网络请求错误的时候 已经提示了 这里先去掉
        }
      })
      return preOrder
    },
    makeSatrack(info, type) {
      console.log('saTrack:', info, '是否限购:', type)
      saTrack('h5_enroll_click', {
        firstChannel: info.channelFirst,
        secondChannel: info.channelSecond,
        salesclerk: info.nickName,
        buy_type: goodTypeStr(info.goodsType),
        goods_ID: info.goodsId + '',
        goods_name: info.goodsName,
        is_limit: type
      })
    },
    // 商品详情查询后，检查购买行为
    enterAfterLogin(res, md = true) {
      bindUserReferrer(this.$store, '商品详情')
      let { goodsInfoList: list } = res
      this.goodsInfoList = res
      this.saData = {
        activity_id: this.goodsInfoList.shareId, //活动id
        goods_id: this.goodsInfoList.goodsIds?.join(','), //商品id
        camp_id: this.goodsInfoList.campId, //体验营id
        inviter_id: this.goodsInfoList.fromUid, //邀请者id
        poster_id: this.goodsInfoList.shareUrlId, //海报id
        poster_type: this.goodsInfoList.posterType,
        poster_name: this.goodsInfoList.shareUrlName, //海报名称
        salesman_id: this.goodsInfoList.adminUserId, //销售id
        ops_type: this.goodsInfoList.operationName, //运营位类型
        ops_id: this.goodsInfoList.operationId, //运营位id
        exp_page: this.goodsInfoList.positionName, //展示页面
        poster_id: this.goodsInfoList.imgId, //海报id
        poster_name: this.goodsInfoList.imgName, //海报名称
        goods_ID: list[0].goodsId, //商品id
        Landing_page: list[0].goodsGuideName, //落地页
        channel_first: this.goodsInfoList.channelFirst, //一级渠道
        channel_second: this.goodsInfoList.channelSecond, //二级渠道
        web_type: '商品',
        web_name: '购买落地页'
      }
      saTrack(
        'autoTrack',
        {
          ...this.saData
        },
        'quick'
      )

      // 协议分类：1:无限卡，2:新无限卡，3:外刊年卡，4:全站卡,0:无协议
      console.log('enterAfterLogin init', res)
      if (list && list.length) {
        const agreementType = list[0].agreementType
        this.protocolType = agreementType
        if (agreementType) {
          if (
            agreementType === 1 ||
            agreementType === 2 ||
            agreementType === 5 ||
            agreementType === 6 ||
            agreementType === 7
          ) {
            this.protocolName = '《友邻少年无限卡会员套餐协议》'
          } else if (agreementType === 3) {
            this.protocolName = '《友邻少年外刊课程会员套餐协议》'
          } else if (agreementType === 4) {
            this.protocolName = '《友邻少年畅听卡套餐协议》'
          } else if (agreementType === 8) {
            this.protocolName = '《2024友邻少年-美国游学之旅购买协议书》'
          } else if (agreementType === 9) {
            this.protocolName = '《友邻少年外刊课程会员套餐协议》'
          }
        }
        list.forEach(item => {
          saTrack('enroll_page_view', {
            firstChannel: res.channelFirst || '',
            secondChannel: res.channelSecond || '',
            salesclerk: res.nickName || '',
            buy_type: goodTypeStr(item.goodsType),
            goods_ID: item.goodsId || '',
            goods_name: item.goodsName
          })
        })
      }
      if (!list) {
        list = res
      }

      // 先处理单商品
      if (list && list.length !== 1) {
        return list
      }
      // 无限卡增订版 预发布的时候 底部的立即购买按钮显示商品上架的时间
      // 所有商品--按钮显示商品上架的时间
      if (list) {
        this.buttonInfo = list[0].btnInfo ? list[0].btnInfo + '开始报名' : '立即报名'
        if (list[0].btnInfo) {
          this.canClick = false
          let nowTime = new Date() * 1
          let startTime = new Date(list[0].btnInfo) * 1
          let time = startTime - nowTime
          console.log(time)
          if (time > 0) {
            setTimeout(() => {
              this.canClick = true
              this.buttonInfo = '立即报名'
            }, time)
          }
        }
      }
      if (this.isVipForeverIncrease || this.isIncrease) {
        try {
          // 调用IOS的方法 允许左滑手势
          const bridge = window.WebViewJavascriptBridge
          if (bridge) {
            bridge.send('allowsBackForwardGestures', 'disable')
          }
        } catch (e) {
          console.log(e)
        }
      }
      console.log('objectobjectobjectobjectobjectobject')
      return this.$store
        .dispatch('user/login/enterAfterLogin', { action })
        .then(action => {
          console.log('enterAfterLogin success', action)
          // //自动登录之后重新塞进埋点信息saData里user信息
          // this.saData['user_id_h5'] = appUser.userId
          // this.saData['user_info'] = appUser
          // 如果是无限卡，查询历史抵扣商品
          if (this.isVipForever || this.isVipForeverIncrease) {
            const { goodsId } = list[0]
            const { userId } = appUser
            console.log(!this.hasToken({ action }), ';;;;;!this.hasToken({ action })')
            if (!this.hasToken({ action })) return
            this.preCreate({ goodsId: list[0].goodsId }, true)
              .then(order => {
                let orderAmount = order.orderAmount
                if (order.couponList && order.couponList.length > 0) {
                  orderAmount = orderAmount - order.couponList[0].couponDiscount
                }
                this.ygOrderAmount = orderAmount < 0 ? 0 : (orderAmount || 0).toFixed(2)
              })
              .catch(orderError => {
                this.ygOrderAmount = this.goodsInfo.salePrice
              })

            this.$store.dispatch('payment/order/getDisCountOrderList', {
              goodsId,
              userId
            })
          }
          if (localStorage.getItem('isClickRegister') === 'true') {
            this.$nextTick(this.onClickPay)
          } else {
            // this.$nextTick(this.$refs.vipForever2021.detailView('goods-order-list'))
          }
          localStorage.setItem('isClickRegister', 'false')
          return action
        })
        .catch(error => {
          console.log('enterAfterLogin err', error)
          if (!error) {
            // 如果是无限卡，查询历史抵扣商品
            if (this.isVipForever || this.isVipForeverIncrease) {
              const { goodsId } = list[0]
              const { userId } = appUser
              console.log(!this.hasToken({ action }), ';;;;;!this.hasToken({ action })')
              if (!this.hasToken({ action })) return
              this.preCreate({ goodsId: list[0].goodsId }, true)
                .then(order => {
                  let orderAmount = order.orderAmount
                  if (order.couponList && order.couponList.length > 0) {
                    orderAmount = orderAmount - order.couponList[0].couponDiscount
                  }
                  this.ygOrderAmount = orderAmount < 0 ? 0 : (orderAmount || 0).toFixed(2)
                })
                .catch(orderError => {
                  this.ygOrderAmount = this.goodsInfo.salePrice
                })
              this.$store.dispatch('payment/order/getDisCountOrderList', {
                goodsId,
                userId
              })
            }
          }
        })
    },
    async getGoodsDetail() {
      if (this.fromIntegral) {
        this.$store.dispatch('integral/index/integralInfo', {
          currentPage: 1,
          pageSize: 10
        })
      }
      const data = {
        goodsIds: this.goodsIdArr || [],
        shareCode: this.shareCode || ''
      }
      this.$store
        .dispatch('goods/vip/getDetailByGoodsId', data)
        // 检查支付操作（登录成功之后）继续
        .then(res => {
          this.enterAfterLogin(res)
          this.$nextTick(_ => {
            this.FooterHeight = document.querySelector('.footer').clientHeight
            console.log('FooterHeight', this.FooterHeight)
          })
        })
    },
    // 设置分享数据
    setShareData() {
      const { shareMainTitle: title, shareSecondTitle: desc, shareImg: imgUrl } = this.defaultGoods
      if (title) {
        const link = location.href
        return { title, desc, link, imgUrl }
      }
    },
    chooseGoodsFn(ind, agreementType, data) {
      this.goodsIndex = ind
      this.protocolType = agreementType
      if (agreementType) {
        if (
          agreementType === 1 ||
          agreementType === 2 ||
          agreementType === 5 ||
          agreementType === 6 ||
          agreementType === 7
        ) {
          this.protocolName = '《友邻少年无限卡会员套餐协议》'
        } else if (agreementType === 3) {
          this.protocolName = '《友邻少年外刊课程会员套餐协议》'
        } else if (agreementType === 4) {
          this.protocolName = '《友邻少年畅听卡套餐协议》'
        } else if (agreementType === 8) {
          this.protocolName = '《2024友邻少年-美国游学之旅购买协议书》'
        } else if (agreementType === 9) {
          this.protocolName = '《友邻少年外刊课程会员套餐协议》'
        }
      }
      saTrack(
        'autoTrack',
        {
          ...this.saData,
          goods_ID: data.goodsId, //商品id
          Landing_page: data.goodsGuideName //落地页
        },
        'quick'
      )
    },
    onIntegralClickFn() {
      // appUser.isNative
      if (this.integralInfo.disCountNum > 0) {
        return $gotoPosterPage()
      }
      this.onClickPay()
    },
    onClickFn() {
      saTrack('signUpClick', {
        ...this.saData,
        desc: '点击立即报名',
        web_name: '购买落地页'
      })
      if (this.goodsDetail.length > 1) {
        // 多商品购买
        this.isShow = true
      } else {
        // 增订版拦截勾选协议
        if (
          this.protocolType !== 0 &&
          !this.protocolBool &&
          (this.isSubVipForever || this.isVipForeverIncrease || this.protocolType === 8)
        ) {
          return this.$toast('请先勾选购买协议')
        }
        if (this.vipActivityGoodsId === this.goodsInfo.goodsId) {
          this.signUp()
          return
        }
        this.onClickPay()
      }
    },
    // 检查用户
    hasUser() {
      // 无token去登录
      if (!this.hasToken({ action })) {
        toLoginView({ type: 'button', action })
        return false
      }
      return true
    },
    zero(num) {
      return (num <= 9 ? `0${num}` : num).toString()
    },
    onClickPay: throttle(
      function () {
        localStorage.setItem('isClickRegister', 'true')
        if (!this.hasUser({ action })) {
          return
        }
        if (this.isVipForeverIncrease && !this.hasConfirmToBuy) {
          const year = new Date().getFullYear()
          this.showMessagePop(
            '温馨提示',
            `您所购买的无限卡权益包含${year}年12月31日前友优课APP内所有上架的专辑(694门)且此权益永久有效；${
              year + 1
            }年之后的新专辑可以以1元/年的费用进行增订。`,
            'toBuy'
          )
          return
        }
        this.hasConfirmToBuy = false
        // 无限卡需要勾选协议
        const { vipForever } = this.$refs
        if (vipForever && !vipForever.isChecked()) {
          return
        }
        console.log(this.goodsInfo, 'this.goodsInfo715')
        // 0元产品直接购买
        if (this.goodsInfo.salePrice === 0 && !this.goodsInfo.isNeedAddress && !this.fromIntegral) {
          this.createOrder()
          return
        }
        // 跳转订单支付
        this.preCreate(this.goodsInfo).then(data => {
          this.preCreateDetail = data
          this.makeSatrack(this.goodsInfo, false)

          // 先检查是否是无限卡续订商品 如果是的话需要判断是否可以续订
          if (data.renewalInfo && data.renewalInfo.type) {
            if (data.renewalInfo.type === 'notBuy') {
              // 不需要续订
              Toast({ message: data.renewalInfo.message, position: 'middle' })
              saTrack('signUpClick', {
                ...this.saData,
                result: data.renewalInfo.message
              })
            } else if (data.renewalInfo.type === 'canBuy') {
              // 需要续订的提示后去付款页面
              this.showMessagePop('温馨提示', data.renewalInfo.message, 'nextBuy')
              saTrack('signUpClick', {
                ...this.saData,
                result: data.renewalInfo.message
              })
            } else if (data.renewalInfo.type === 'overdue') {
              saTrack('signUpClick', {
                ...this.saData,
                result: data.renewalInfo.message
              })
              // 有逾期未还
              document.documentElement.style.overflow = 'hidden'
              const messageWithStyle =
                `<span style="color:#666666;font-size: 14px;text-align: left;display: block">` +
                data.renewalInfo.message +
                `</span>`
              MessageBox.alert(messageWithStyle, '温馨提示', {
                confirmButtonText: '立即还款',
                closeOnClickModal: false
              }).then(action => {
                document.documentElement.style.overflow = ''
                window.location.href = data.renewalInfo.url
              })
            }
            return
          }
          saTrack('signUpClick', {
            ...this.saData,
            result: '成功'
          })
          this.orderView()
        })
      },
      1000,
      { leading: true }
    ),
    orderView() {
      // 家庭卡购买
      if (this.isSubVipForever) {
        this.$store.commit('goods/vip/saveCommitmentDetails', {
          goodsId: this.goodsInfo.goodsId
        })
        return this.$router.push('subVip-commitmentView')
      }

      this.$router.push({
        path: `/confirm-order/${this.goodsInfo.goodsId}`,
        query: { paytype: 'goods' }
      })
    },
    // 查看无限卡协议
    checkProtocol() {
      // 协议分类：1:无限卡，2:新无限卡，3:外刊年卡，4:全站卡,0:无协议
      if (this.protocolType === 1) {
        this.$router.push({
          name: 'goods-vip-forever-protocol'
        })
      } else if (this.protocolType === 2) {
        this.$router.push({
          name: 'goods-vip-forever-protocol2022'
        })
      } else if (this.protocolType === 3) {
        this.$router.push({
          name: 'goods-vip-foreign-protocol'
        })
      } else if (this.protocolType === 4) {
        this.$router.push({
          name: 'goods-vip-all-protocol-2024'
        })
      } else if (this.protocolType === 5) {
        this.$router.push({
          name: 'goods-vip-forever-protocol2023'
        })
      } else if (this.protocolType === 6) {
        this.$router.push({
          name: 'goods-vip-forever-protocol20231108'
        })
      } else if (this.protocolType === 7) {
        this.$router.push({
          name: 'goods-vip-forever-protocol2024618'
        })
      } else if (this.protocolType === 8) {
        this.$router.push({
          name: 'goods-merchandise'
        })
      } else if (this.protocolType === 9) {
        this.$router.push({
          name: 'goods-vip'
        })
      }
    },
    showMessagePop(title, message, from) {
      document.documentElement.style.overflow = 'hidden'
      const messageWithStyle =
        `<span style="color:#666666;font-size: 14px;text-align: left;display: block">` + message + `</span>`
      MessageBox.confirm(messageWithStyle, title, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false
      })
        .then(action => {
          document.documentElement.style.overflow = ''
          if (from === 'toBuy') {
            this.hasConfirmToBuy = true
            this.onClickPay()
          } else {
            this.orderView()
          }
        })
        .catch(_ => {
          document.documentElement.style.overflow = ''
        })
    },
    createOrder() {
      const accountId = getAccountId()
      // console.log('accountId',accountId)
      if (accountId == 'ylyk_pub_old') {
        Toast({
          message: '公众号主体已经迁移，请点击右上角刷新重试。',
          position: 'center'
        })
        return
      }
      // 调用原生购买方法
      let source = 'APP'
      if (appUser.isWeixin) source = 'PUB'
      if (appUser.isBrowser) source = 'WEB'

      const userReferrer = getCookie('userReferrer')

      let createData = {
        source,
        payType: 'WX',
        addressId: '',
        amount: 0,
        discount: 0.0,
        goodsId: this.goodsInfo.goodsId,
        installmentId: 0,
        sellerCode: this.shareCode, // 分享者编码
        totalPrice: 0.0,
        userId: appUser.userId,
        openId: appUser.openId,
        userNote: '',
        userReferrer,
        creditCount: 0
      }
      if (appUser.isWeixin && !appUser.openId) {
        // Toast({ message: '请重新报名' })
        appUser.resetToken()
        location.reload()
        return
      }
      localStorage.setItem('isClickRegister', 'false')
      if (this.createLoading) return
      this.createLoading = true
      this.$store
        .dispatch('payment/order/create', createData)
        .then(res => {
          this.createLoading = false
          let order = { ...createData, ...res }
          saTrack('signUpClick', {
            ...this.saData,
            result: '成功'
          })
          this.$store.dispatch('payment/order/getPayStatusTime', order).then(pay => {
            console.log(pay, 'const')
            const { status: payStatus } = pay
            // payStatus = 1 // 测试为成功
            console.log(payStatus, '-----0000')
            if (payStatus >= 1) {
              console.log('支付结果', payStatus, 'data', pay)
              this.routeSuccess(pay)
            } else {
              console.log('支付失败')
              Toast({ message: '订单正在处理，请稍后查询', position: 'bottom' })
            }
          })
        })
        .catch(err => {
          this.createLoading = false
          saTrack('signUpClick', {
            openId: createData.openId,
            ...this.saData,
            result: err.message
          })
          let { code, message, data } = err
          if ([30425, 30025, 30430, 30443].indexOf(code) >= 0) {
            this.errorData = data
            switch (code) {
              case 30425:
                this.errorData.errorMessage = `您已购买商品或已获得更高权益<br/>详情请咨询班主任`
                break
              case 30025:
                this.errorData.errorMessage = `您已购买过体验营，详情请咨询班主任`
                break
              case 30430:
                this.errorData.errorMessage = `您已购买过体验营，请联系班主任，激活课程权益`
                break
              case 30443:
                this.errorData.errorMessage = `该商品仅支持友邻少年无限卡用户购买<br/>详情请咨询班主任`
                break
              default:
                this.errorData.errorMessage = message
                break
            }
            this.messageShow = true
            return
          }
          console.log(err)
          Toast({ message: err.message })
        })
    },
    // 跳转成功页面
    routeSuccess(data) {
      const { goods_id: goodsId } = data
      const params = { id: goodsId }
      console.log('准备跳转成功页面', params)
      let name = 'success'
      // 训练营/体验营 的成功页面
      const { campNo, userSno, startDate, adviserCode, iconUrl, adviserName, adviserUrl } = data || {}
      // if (campNo) {
      //   const userId = appUser.userId + ''
      //   const bool = userId.substr(userId.length - 1, 1) < 5
      //   console.log('当前-userId---', userId, '是否0-4------------', bool)
      //   name = 'campSuccess'
      //   if (bool) name = 'newCampSuccess'
      //   const campDate = Date.getUTCDate(startDate, {
      //     format: 'yyyy年MM月dd日'
      //   })
      //   this.$store.commit('payment/order/setPayStatus', {
      //     goodsId,
      //     campNo,
      //     userSno,
      //     campDate,
      //     iconUrl,
      //     adviserName,
      //     adviserUrl,
      //     adviserCode
      //   })
      // }
      // 家庭卡购买成功
      if (this.isSubvipGoods) {
        name = 'subVip-paySuccess'
      }
      this.$router.replace({ name, params })
    },
    // 是否参加活动
    signUp() {
      if (!this.hasUser({ action })) {
        return
      }
      activityService.isVipActivity().then(res => {
        switch (res.goType) {
          case 'vip':
            // this.$toast('敬请期待')
            this.$router.push({ path: 'vipGroup' })
            break
          case 'foreverVip':
            this.$router.push({ path: 'foreverVip' })
            break
          case 'camp':
            // this.$router.push({ path: 'goods', query: { goodsId: 104305 } })
            this.onClickPay()
            break
          default:
            break
        }
      })
    },
    getUrlScheme() {
      let adviserCode = this.errorData.adviserCode
      let data = {
        goodsType: this.errorData.goodsInfo.goodsType,
        goodsId: this.errorData.goodsInfo.goodsId,
        adviserCode: adviserCode
      }
      goWeixin(1, data)
    },
    getPreCreate() {
      orderService.preCreate(data)
    },
    nativeGoMini(event) {
      this.$store.dispatch('user/login/getMiniParam', {}).then(mini => {
        $gotoMiniProgramV2({
          miniUserName: mini.miniUserName,
          goMiniUrl:
            'pages/rights_receive/app_add_headTeacher/app_add_headTeacher?userId=' + appUser.userId + '&sceneId=3'
        })
      })
    }
  }
}
</script>

<style lang="less">
.goods-page {
  &::-webkit-scrollbar {
    display: none;
    background-color: transparent;
  }
  .content {
    img {
      width: 100%;
      height: auto;
    }
  }
  .foot {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 10;
    border-top: 1px solid #eeeeee;
    // iphoneX only
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
    background-color: #fff;
    // 活动抵扣
    .activity_box {
      position: absolute;
      top: -0.75rem;
      left: 0;
      width: 100%;
      height: 0.88rem;
      background-image: url('../../images/goods0929/act_bg.png');
      background-size: 100% 100%;
      font-size: 0.26rem;
      .act_left,
      .act_right {
        padding-bottom: 6px;
      }
      .act_left {
        width: 45%;
        color: #fff;
        justify-content: center;
        img {
          width: 0.36rem;
          height: 0.36rem;
          margin-right: 0.08rem;
        }
        span {
          font-weight: 600;
        }
      }
      .act_right {
        flex: auto;
        text-align: center;
        justify-content: center;
      }
      .act_right,
      .countDown_box {
        font-weight: 600;
        color: #e6432d;
      }
    }
    .footer {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0.18rem 0.47rem;
      border-top: none !important;
      background-color: #fff;

      .price {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        .price-text {
          display: none;
          font-size: 0.32rem;
        }
        .shop-price-integral {
          font-size: 0.36rem;
          font-weight: bold;
          line-height: 0.54rem;
          span {
            color: #00b25a;
          }
        }
        .shop-price {
          font-size: 0.44rem;
          color: #00b25a;
          font-weight: bold;
          line-height: 0.54rem;
          display: flex;
          align-items: center;
        }
        .original-price {
          color: #999999;
          font-size: 0.26rem;
          line-height: 0.32rem;
          margin-top: 0.1rem;
        }
      }
      .price-wxk {
        .price-text {
          display: block;
        }
        .original-price {
          padding-left: 1.9rem;
        }
      }
      .btn {
        padding: 0.24rem 0.4rem;
        background-color: #00b25a;
        border-radius: 0.12rem;
        color: #fff;
      }
      .btn-click-disable {
        pointer-events: none;
        background-color: #bbbbbb;
        max-width: 3rem;
        font-size: 0.28rem;
        text-align: center;
      }
    }
    .protocol_box {
      font-size: 0.28rem;
      padding: 0 0.47rem 0.3rem 0.47rem;
      justify-content: flex-start;
      .choose_img_box {
        width: 0.32rem;
        height: 0.32rem;
        margin-right: 3px;
      }
      .warning_text {
        color: #e6432d;
      }
    }
  }

  .warning {
    position: fixed;
    left: 0;
    display: flex;
    width: 100%;
    align-items: center;
    background: #fff2cc;
    padding: 0.07rem 0.07rem 0.07rem 0.24rem;
    font-size: 0.24rem;
    height: 0.4rem;
    z-index: 10;
    .warning-text {
      color: #e65c53;
      text-decoration: underline;
      height: 0.4rem;
      line-height: 0.4rem;
    }
  }
  .tyy-text {
    justify-content: center;
    color: #ff5b4c;
    font-size: 0.28rem !important;
    padding: 0.2rem 0 !important;
    height: 0.64rem !important;
    font-weight: bold;
  }
  .mask {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 99;
  }
  .wrap {
    width: 100%;
    position: fixed;
    left: 0;
    bottom: 0;
    padding: 30px 20px 20px;
    background-color: #fff;
    .closeMask {
      display: flex;
      padding: 16px;
      position: absolute;
      top: 0;
      right: 0;
      img {
        width: 16px;
        height: 16px;
      }
    }
    .share-icon {
      width: 81px;
      height: 81px;
      img {
        width: 81px;
        height: 81px;
        border-radius: 2px;
      }
    }
    .good-info {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-left: 10px;
      .good-name {
        font-size: 18px;
        line-height: 22px;
      }
      .good-price {
        font-weight: bold;
        font-size: 18px;
        margin-top: 6px;
        color: #c42a1c;
      }
    }
    .goods-item {
      margin-top: 0.6rem;
      display: flex;
      flex-direction: column;
      .tit {
        font-size: 0.34rem;
      }
      .good-name {
        display: flex;
        > span {
          margin-top: 0.3rem;
          margin-right: 0.2rem;
          padding: 0.15rem 0.2rem;
          text-align: center;
          line-height: 0.4rem;
          font-size: 0.24rem;
          border-radius: 0.08rem;
          background-color: #eee;
          color: #666;
          // &:last-child {
          //   margin-right: .2rem!important;
          // }
        }
        .active {
          background-color: #00b25a;
          color: #fff;
        }
      }
    }
    .btn {
      width: 100%;
      padding: 0.24rem 0;
      margin-top: 0.4rem;
      color: #fff;
      font-size: 0.32rem;
      border-radius: 0.04rem;
      background-color: #00b25a;
    }
  }
}
.message-popup {
  img {
    width: 3.2rem;
    height: 3.2rem;
    margin-bottom: 0.24rem;
  }
  .txt-center {
    line-height: 0.4rem;
  }
}
</style>
